<script setup>
defineProps({
  contained: Boolean
});
</script>

<template>
  <div
    :class="{ 'bg-background p-1': contained }"
    class="flex flex-wrap items-center rounded-lg text-nowrap lg:justify-between"
  >
    <slot />
  </div>
</template>
